import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CodeModalComponent } from 'src/app/modules/proof-of-delivery/components/code-modal/code-modal.component';

@Injectable({ providedIn: 'root' })
export class CodeModalService {

  constructor(private modalService: NgbModal) {}

  /** Opens the CodeModalComponent using NgbModal and returns a promise resolving with the entered code or null */
  open(): Promise<string | null> {
    const modalRef = this.modalService.open(CodeModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    return modalRef.result;
  }
}